import React from 'react'

import SidebaramenitiesMobile from './sidebarMobile.component'

interface Props{
  isamenities: boolean,
  amenitiesData: any,
  colorsData: any,
  handleamenitiesMenySelection: any,
  handleamenitiesFilter: any,
  amenitiesFilterId: string,
  handleOpenAmenitiesSpin: any,
  handleCloseAmenitieSpin: any
}

interface State{}

class AmenitesContainerMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {}
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isamenities ? 'amenities-container-mobile fade-in':'amenities-container-mobile fade-out'} style={{pointerEvents: "none"}}>
          {
          this.props.isamenities ? 
            <SidebaramenitiesMobile
              amenitiesData={this.props.amenitiesData}
              colorsData={this.props.colorsData}
              handleamenitiesMenySelection = {this.props.handleamenitiesMenySelection}
              handleamenitiesFilter = {this.props.handleamenitiesFilter}
              amenitiesFilterId = {this.props.amenitiesFilterId}
              handleOpenAmenitiesSpin = {this.props.handleOpenAmenitiesSpin}
              handleCloseAmenitieSpin = {this.props.handleCloseAmenitieSpin}
            />:null
          }
        </div>
      )
  }
}

export default AmenitesContainerMobile